import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";

import { cn } from "../../shared/utils";

import { specialityList } from "../../lib/api";
import { useStore } from "../../store";

const Specialties = (props) => {
  let navigate = useNavigate();

  const [isLoading, setLoader] = useState(true);
  const colors =['green-200','red-200','blue-200','orange-200','yellow-100']
  const [specialities, setSpecialities] = useState([]);
  const [updatedSpecialties, setUpdatedSpecialties] = useState([]);
  const setSelectedSpecialties = useStore(
    (state) => state.setSelectedSpecialties
  );
  const selectedSpecialties = useStore((state) => state.selectedSpecialties) ;

  const handleSpecialtyClick = (specialty) => {
    const isSelected = updatedSpecialties?.some(
      (selected) => selected.id === specialty.id
    );
    const updatedSpecialtyList = isSelected
      ? updatedSpecialties?.filter((selected) => selected.id !== specialty.id)
      : [...updatedSpecialties, specialty];
      // console.log(isSelected,specialty,'updatedSpecialtyList',updatedSpecialtyList,)
    // Update the state or perform any other necessary actions
    setUpdatedSpecialties(updatedSpecialtyList);

  };
  const handleContinue = () => {
    setSelectedSpecialties(updatedSpecialties);
    navigate('/schedule')
  }
  

  useEffect(() => {
    getSpecialty();
  }, []);

  const getSpecialty = async () => {
    if (sessionStorage.getItem("specialities")) {
      const specialities = JSON.parse(sessionStorage.getItem("specialities"));
      setSpecialities(specialities);
      console.log(selectedSpecialties,'selectedSpecialties')
      setUpdatedSpecialties([...selectedSpecialties])
      return;
    }
    const res = await specialityList();
    const specialities = res?.data?.result;
    if (!specialities) {
      setSpecialities([]);
    } else {
      setSpecialities(specialities);
      sessionStorage.setItem("specialities", JSON.stringify(specialities));
      setUpdatedSpecialties([...selectedSpecialties])

    }
  };

  return (
    <div className="bg-white min-sh-screen">
      <>
        {" "}
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="/schedule">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-sm">Doctors specialties</h4>
              </div>
            </Link>
          </div>
        </div>
        <div className=" flex-1 overflow-scroll hideScroll  text-gray-500  flex flex-col pt-12 px-4 pb-16">
          <div className="mt-8">
            <div className=" text-slate-700 text-xl font-medium ">
              Can you select which speciality to schedule the appointment?
            </div>
          </div>

          <div className="grid grid-cols-3 md:grid-cols-5 gap-4 mt-8  mb-8">
            {specialities?.map((speciality, index) => (
              <div
                key={index}
                className="flex flex-col justify-center items-center cursor-pointer"
                onClick={() => handleSpecialtyClick(speciality)}
              >
                <div
                  className={`relative flex flex-col items-center justify-center py-4  px-4  rounded-[18px] border ${
                    updatedSpecialties?.some(
                      (selected) => selected.id === speciality.id
                    )
                      ? "border-blue-500 "
                      : ""
                  } bg-${colors[index % colors.length]}`}
                >
                  <div
                    className={` ${
                      updatedSpecialties?.some(
                        (selected) => selected.id === speciality.id
                      )
                        ? " round"
                        : ""
                    }`}
                  ></div>
                  <img
                    className="w-12 h-12"
                    src={speciality.icon_url}
                    alt={speciality.name}
                  />
                </div>
                <p className="text-center text-slate-700 text-sm font-normal">
                  {speciality.name}
                </p>
              </div>
            ))}
          </div>

          
        </div>
        <div className="bg-white h-16 fixed bottom-0 w-full pt-1 flex justify-center" onClick={() => handleContinue()}>
            <button className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold">
              Continue
            </button>
          </div>
      </>
    </div>
  );
};

export default Specialties;
